import { Component, Input } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { DTextareaFormControl } from "../../entities/form-control";
import { FormField } from "../../entities/form-field";

@Component({
	selector: "form-textarea",
	template: `
		<div class="dynamic-field form-textarea" [formGroup]="group">
			<label>
				<ng-content select="h3" />

				<textarea
					[formControlName]="config.name"
					[maxlength]="config.maxLength"
					[minlength]="config.minLength"
					[placeholder]="placeholder | i18n"
				>
				</textarea>
			</label>
		</div>
	`,
	standalone: false,
})
export class FormTextareaComponent implements FormField {
	@Input() config: DTextareaFormControl;
	@Input() group: UntypedFormGroup;

	get placeholder() {
		return this.config.placeholder || "";
	}
}
